/* In-cart recommendations: one-tap add for .leon-rec cards.
   Cards are injected via innerHTML on every cart rebuild, so handlers
   are delegated at document level and survive re-renders. */
(function() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-leon-rec-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var card = btn.closest('[data-leon-rec]');
    var sel = card && card.querySelector('[data-leon-rec-variant]');
    var id = parseInt(sel ? sel.value : btn.getAttribute('data-variant-id'), 10);
    if (!id) return;

    btn.disabled = true;
    btn.classList.add('btn--loading');

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function(r) {
        if (!r.ok) throw new Error('cart add failed');
        return r.json();
      })
      .then(function() {
        // Rebuild every cart form (drawer and cart page) from /cart?view=ajax
        document.dispatchEvent(new CustomEvent('cart:build'));
      })
      .catch(function() {
        btn.disabled = false;
        btn.classList.remove('btn--loading');
      });
  });
})();
